import { subDays, format } from "date-fns";
import { ALL_DAYS_DATE } from "../config";
import { utcToZonedTime, format as formatTz } from "date-fns-tz";
import { MetaProps } from "../types/mockData";

// start é a recente
// end é a antiga

const timeZone = "America/Sao_Paulo";

export function dateFormat(lastDays: number | null, total?: null) {
  let newFormatStartDate = "";
  let newFormatEndDate = "";

  const nToday = new Date();
  const zonedToday = utcToZonedTime(nToday, timeZone);
  const today = formatTz(zonedToday, "yyyy-MM-dd", { timeZone });

  if (lastDays === null) {
    newFormatStartDate = today;
    newFormatEndDate = ALL_DAYS_DATE;
    return {
      newFormatStartDate,
      newFormatEndDate,
    };
  } else {
    if (lastDays === 0) {
      newFormatStartDate = today;
      newFormatEndDate = today;
    }

    if (lastDays === 1) {
      const zonedYesterday = utcToZonedTime(subDays(nToday, 1), timeZone);
      const yesterday = formatTz(zonedYesterday, "yyyy-MM-dd", { timeZone });
      newFormatStartDate = yesterday;
      newFormatEndDate = yesterday;
    }

    if (lastDays !== 0 && lastDays !== 1) {
      const lastXDays = formatTz(subDays(nToday, lastDays), "yyyy-MM-dd", { timeZone });
      newFormatStartDate = today;
      newFormatEndDate = lastXDays;
    }

    return {
      newFormatStartDate,
      newFormatEndDate,
    };
  }
}

type ObjetoVisitas = {
  dia: string;
  visitasRecorrentes: number;
  visitasUnicas: number;
  visitasTotais: number;
};

export function dateShortForNewer(
  array: ObjetoVisitas[] | MetaProps[],
): ObjetoVisitas[] | MetaProps[] {
  return array
    .sort((a, b) => {
      const dataA = new Date(a.dia);
      const dataB = new Date(b.dia);
      return dataB.getTime() - dataA.getTime();
    })
    .reverse();
}

type ObjetoSalesByHour = {
  hora: string;
  quantidadeIngressosVendidos: string | number;
};

export function hourShortForNewer(
  array: ObjetoSalesByHour[],
): ObjetoSalesByHour[] {
  return array
    .sort((a, b) => {
      // Ordena por string de hora no formato "HH:mm"
      return a.hora.localeCompare(b.hora);
    });
}

export function removeThisFnWhenCleitonFinishCorrectionOnGoalsDate(
  data: string,
  year: string | undefined
): string {
  const dataObj = new Date(data);
  const zonedDataObj = utcToZonedTime(dataObj, timeZone);
  const dia = formatTz(zonedDataObj, "dd", { timeZone });
  const mes = formatTz(zonedDataObj, "MM", { timeZone });
  const ano = formatTz(zonedDataObj, "yyyy", { timeZone });
  if (year !== undefined) return `${dia}/${mes}/${ano}`;
  return `${dia}/${mes}`;
}

export function parseDate(date: Date | null) {
  if (date) return format(date, 'dd/MM/yyyy');
  return null
}
export function inParseDate(date: string) {
  const dia = date.slice(0,2)
  const mes = date.slice(3,5)
  const ano = date.slice(6,10)
  return `${ano}-${mes}-${dia}T03:00:00.000`
}
